import axios from "axios";
import {BASE_URL} from "../constants";

// const BASE_URL = process.env.REACT_APP_API_URL || "https://zsafedocs-backend-424844719658.us-central1.run.app";

// Generic GET request
export const getData = async (endpoint, params = {}) => {
  try {
    const response = await axios.get(`${BASE_URL}${endpoint}`, { params });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

// Generic POST request
export const postData = async (endpoint, data, headers = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}${endpoint}`, data, { headers });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const postStreamData = async (endpoint, data) => {
  try {
      const response = await axios({
          method: 'POST',
          url: `${BASE_URL}${endpoint}`,
          data: data,
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'text/event-stream'
          },
          responseType: 'text',
          onDownloadProgress: data.onDownloadProgress
      });
      return response;
  } catch (error) {
      throw error;
  }
};

// Generic PUT request
export const putData = async (endpoint, data, headers = {}) => {
  try {
    const response = await axios.put(`${BASE_URL}${endpoint}`, data, { headers });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

// Generic DELETE request
export const deleteData = async (endpoint, headers = {}) => {
  try {
    const response = await axios.delete(`${BASE_URL}${endpoint}`, { headers });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

// Handle API errors
const handleApiError = (error) => {
  console.error("API Error:", error.response?.data || error.message);
  throw error.response?.data || error.message;
};

// Get task status by task_id
export const getTaskStatus = async (taskId) => {
  try {
    const response = await axios.get(`${BASE_URL}/api/documents/status/${taskId}`);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};